import { DASHBOARDS_LINK_TITLE } from "components/navigation/bindings";
import Routes from "routing/Routes";
const DefaultEnterpriseNavItem = {
  description: "Enterprise",
  position: { after: DASHBOARDS_LINK_TITLE },
  path: Routes.SYSTEM.ENTERPRISE
};
export default DefaultEnterpriseNavItem;
